import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionMeta, MultiValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { FormGroup } from 'reactstrap';
import EnumInput from '../../../../misc/EnumInput';
import { OptionItem, OnChangeCallback, SearchableOptionItem } from "../../../../../util/UtilityTypes";
import { useTranslation } from 'react-i18next';
import { RequestState } from "../../../../../models/RequestState";
import { ListInformationMarkings } from "../../../../../store/ActivityInformationMarkingsAction";
import StatusCode from "../../../../../util/StatusCode";
import { RootState } from '../../../../../store/store';


interface InformationMarkingsInputProps {
    onChange: OnChangeCallback<string[] | undefined>
    selectedValues?: string[]
    name: string
    disabled?: boolean
}

const ALL = 0;
const ONLY_SELECTED = 1

const toCreatableValues = (selectedValues: string[] | undefined): SearchableOptionItem<string>[] => {
    if (selectedValues === undefined || selectedValues === null) {
        return [];
    }
    return selectedValues.map((item) => {
        return {
            value: item,
            label: item
        }
    });
}


const InformationMarkingsInput = (props: InformationMarkingsInputProps) => {
    const { t } = useTranslation(['configuration', 'common']);

    const dispatch = useDispatch();
    const existningMarkings = useSelector<RootState, RequestState<string[]>>(state => state.activityInformationMarkings.informationMarkings);
    
    useEffect(() => {
        ListInformationMarkings()(dispatch);
    }, [dispatch]);

    const enumOptions: OptionItem<number>[] = [
        { value: ALL, text: t('informationMarkings.all', { ns: 'configuration' }) },
        { value: ONLY_SELECTED, text: t('informationMarkings.selectedOnly', { ns: 'configuration' }) },
    ]

    var enumValue = ALL;
    if (props.selectedValues == null // user clicked the radio button, but no filter added yet
        ||
        props.selectedValues.length > 0) {
        enumValue = ONLY_SELECTED;
    }

    const setMarkingFilter = (name: string, value: number) => {
        props.onChange(props.name, value === ALL ? [] : undefined);
    }   

    const handleChange = (option: MultiValue<SearchableOptionItem<string>>, action: ActionMeta<SearchableOptionItem<string>>) => {
        props.onChange(props.name, option.map(x => x.value))
    }

    return (
        <FormGroup>
            <EnumInput
                title={t('informationMarkings.title', { ns: 'configuration' })}
                value={enumValue}
                options={enumOptions}
                onChange={(k, v) => setMarkingFilter(k, v)}
                disabled={props.disabled}
                name='informationMarkingEnable'
            />
            <CreatableSelect
                isMulti
                onChange={handleChange}
                options={existningMarkings.code === StatusCode.COMPLETE ? toCreatableValues(existningMarkings.data) : []}
                value={toCreatableValues(props.selectedValues)}
                isDisabled={enumValue === ALL || props.disabled}
                formatCreateLabel={(inputText) => t('action.add', { ns: 'common' }) + ` "${inputText}"`}
                placeholder={t('informationMarkings.select', { ns: 'configuration' })}
                noOptionsMessage={() => t('informationMarkings.noOptions', { ns: 'configuration' })}
            />
        </FormGroup>
    );
}

export default InformationMarkingsInput;